import instance from "@/plugins/axios";
import { ResponseResult } from "@/core/models/response-result";
import {
  AbstractExecutiveDashboardRemoteDataSource,
  GetExecutiveDashboardDataParams,
} from "@/modules/executiveDashboard/remote/AbstractExecutiveDashboardRemoteDataSource";
import { ExecutiveDashboard } from "@/modules/executiveDashboard/models/executive-dashboard";
import { DashboardEntry } from "@/core/models/dashboard-entry";
import { DonutChart } from "@/modules/executiveDashboard/models/donut-chart";
import { HeatChart } from "@/modules/executiveDashboard/models/heat-chart";
import { DashboardTrend } from "../models/dashboard-trend.enum";

export class ExecutiveDashboardRemoteDataSource
  implements AbstractExecutiveDashboardRemoteDataSource
{
  async getExecutiveDashboardData(
    params: GetExecutiveDashboardDataParams,
  ): Promise<ResponseResult> {
    try {
      const response = (
        await instance.get<ResponseResult<any>>("Events/dashboard/executive", {
          params,
        })
      ).data;

      if (!response.isSuccess) return response;

      response.data = this.convertFromJsonToExecutiveDashboard(response.data);
      return response;
    } catch (error) {
      console.error(error);
      return ResponseResult.defaultError(error);
    }
  }

  convertFromJsonToExecutiveDashboard(data: any): ExecutiveDashboard {
    return {
      activeEvents:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.activeEvents,
        ),
      estimatedCost:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.estimatedCost,
        ),
      occupation:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.occupation,
        ),
      margin:
        ExecutiveDashboardRemoteDataSource.convertFromJsonToDashBoardEntry(
          data.margin,
        ),
      donutChart: this.convertFromJsonToDonutChart(data.typeDistribution),
      heatChart: this.convertFromJsonToHeatChart(data.heatmap),
    };
  }

  static convertFromJsonToDashBoardEntry(data: any): DashboardEntry {
    return {
      value: data.value,
      change: data.change,
      trend: data.trend as DashboardTrend,
    };
  }

  convertFromJsonToDonutChart(data: any[]): DonutChart[] {
    return data.map((item) => ({
      name: item.type,
      value: item.percentage,
    }));
  }

  convertFromJsonToHeatChart(data: any): HeatChart {
    const yLength = (data.yLabel as []).length;
    return {
      xLabel: data.xLabel,
      yLabel: (data.yLabel as []).reverse(),
      rows: (data.rows as []).map((row: any) => [
        row.x,
        yLength - 1 - row.y,
        row.value,
      ]),
    };
  }
}
